<template>
  <span class="star-rating">
    <span v-for="star in stars" class="star" :class="{'star-active': active, 'star-half': isHalf(star)}"></span>
  </span>
</template>

<style>

.star-rating {
  display: inline-block;
}

.star-rating > .star {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: transparent url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAhFBMVEUAAAAXaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf9lBnVwAAAAK3RSTlMAAQIDBAgJCgwNDg8REhMVGiMlLzg5Q3SLjpKmq7S6xcfV19rg6Onr7e/7XaoN8AAAAGVJREFUCB1NwYkaQlAUhdG/VCRRadJEaWK///vlHj5Zi1Y4Y+iSMbCSFvydpSOdyXKvxjbygKxS73Mg/qr3DCB6q1P6NMKXzGOKucmcaNUyJcaXdM0ljXHWKjaQ3hXjJCnOaDeHH05tDmy7wjkmAAAAAElFTkSuQmCC") no-repeat center center;
}

.star-rating > .star.star-half {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAqFBMVEUAAAAXaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf8Xaf98fbNGAAAAN3RSTlMAAQMEBQkKDA0ODxESExQVGBodIyYnKi4vOEN4i46RmJumq7K1usHH09fZ2uDi6Onr7e/x9/n7myqHJAAAAHhJREFUCB0FwYtCAVEABcBBRKjNI21IbwqhW53//zMzgF4bALwsAeD29/MKAM+lXgC0Bg8pjW3db+LxJ0mK0fy1HOeGpyQpMN1d0j8kKbjbdqD3nRSqrzbwnhSqFeA/+atc7IFOkrePp8GpCcZZT5htcgOu74G6yxnShw0a+7mEvAAAAABJRU5ErkJggg==");
}

.star-rating > .star.star-active {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAhFBMVEUAAAD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgCGa3CzAAAAK3RSTlMAAQIDBAgJCgwNDg8REhMVGiMlLzg5Q3SLjpKmq7S6xcfV19rg6Onr7e/7XaoN8AAAAGVJREFUCB1NwYkaQlAUhdG/VCRRadJEaWK///vlHj5Zi1Y4Y+iSMbCSFvydpSOdyXKvxjbygKxS73Mg/qr3DCB6q1P6NMKXzGOKucmcaNUyJcaXdM0ljXHWKjaQ3hXjJCnOaDeHH05tDmy7wjkmAAAAAElFTkSuQmCC");
}

.star-rating > .star.star-active.star-half {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAqFBMVEUAAAD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgD/ZgDCk4sDAAAAN3RSTlMAAQMEBQkKDA0ODxESExQVGBodIyYnKi4vOEN4i46RmJumq7K1usHH09fZ2uDi6Onr7e/x9/n7myqHJAAAAHhJREFUCB0FwYtCAVEABcBBRKjNI21IbwqhW53//zMzgF4bALwsAeD29/MKAM+lXgC0Bg8pjW3db+LxJ0mK0fy1HOeGpyQpMN1d0j8kKbjbdqD3nRSqrzbwnhSqFeA/+atc7IFOkrePp8GpCcZZT5htcgOu74G6yxnShw0a+7mEvAAAAABJRU5ErkJggg==");
}

.star-rating > .star + .star {
  margin-left: 2px;
}

</style>

<script>

export default {
  props: ['rating', 'active'],
  computed: {
    stars() {
      return Math.round(this.rating)
    }
  },
  methods: {
    isHalf(star) {
      return star === this.stars && this.rating !== this.stars && this.rating < this.stars
    }
  }
}

</script>


// WEBPACK FOOTER //
// StarRating.vue?71fa4f2e